import { Grid, useElementBreakpoints } from "@compass/core";
import {
    TopicFilter as TopicFilterModel,
    DiplomaTypeFilterResource
} from "generated/openApi";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const TopicFilter = (props: {
    filter: TopicFilterModel;
    setFilter: (value: TopicFilterModel) => void;
}) => {
    const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
    const [resource, setResource] = useState<DiplomaTypeFilterResource>({});

    useEffect(() => {
        ApiService.diplomaTypes.getFilterResource().then((response) => {
            setResource(response);
        });
    }, []);



    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            {/* Filter fields removed for now; keeping structure in place for future use */}
        </Grid>
    );
};
